// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnhelpfulFeedbackChat_wrapper__CAApi","titleWrapper":"UnhelpfulFeedbackChat_titleWrapper__aUpDu","backButton":"UnhelpfulFeedbackChat_backButton__uAm0h"};